import axios from 'axios';
import { BASE_URL } from '@/assets/js/config';
import { getAccessToken } from '@/assets/js/auth';


export const getEmkCookies = async (data) => {
  let tokenData = {"token": data}
  const settings = {
      withCredentials: true,
  };

  return axios.post(`https://emk.fuga.cloud/auth/`, tokenData, settings);
}

export const getEmkNameSpaces = async (apiUrl) => {
  const settings = {
      headers: {
        'x-requested-with': 'XMLHttpRequest',
      },
      withCredentials: true,
  };

  return axios.get(`https://emk.fuga.cloud/api/namespaces`, settings);
}

export const getEmkCloudProfiles = async (apiUrl) => {
  const settings = {
      headers: {
        'x-requested-with': 'XMLHttpRequest',
      },
      withCredentials: true,
  };

  return axios.get(`https://emk.fuga.cloud/api/cloudprofiles`, settings);
}

export const getGardenerExtensions = async (name) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.get(`https://emk.fuga.cloud/api/gardenerextensions`, settings);
}

export const getEmkClusters = async (namespace) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.get(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots`, settings);
}

export const createEmkCluster = async (namespace, data) => {
  const settings = {
      headers: {
        'x-requested-with': 'XMLHttpRequest',
      },
      withCredentials: true,
  };

    return axios.post(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots`, data, settings);
}

export const editEmkCluster = async (namespace, cluster, data) => {
  const settings = {
      headers: {
        'x-requested-with': 'XMLHttpRequest',
      },
      withCredentials: true,
  };

    return axios.put(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}`, data, settings);
}

export const emkClusterAnnotations = async (namespace, cluster, data) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.patch(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}/metadata/annotations`, data, settings);
}

export const getEmkCLusterInfo = async (namespace, clusterId) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };
    return axios.get(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${clusterId}/info`, settings);
}

export const emkClusterMaintenance = async (namespace, cluster, data) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };
    return axios.put(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}/spec/maintenance`, data, settings);
}
export const emkClusterHibernation = async (namespace, cluster, data) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };
    return axios.put(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}/spec/hibernation/schedules`, data, settings);
}

export const emkEnableClusterHibernation = async (namespace, cluster, data) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    // {"gardener.cloud/operation":"maintain"}

    // {"gardener.cloud/operation":"rotate-kubeconfig-credentials"}

    return axios.put(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}/spec/hibernation/enabled`, data, settings);
}

export const deleteEmkCluster = async (namespace, cluster) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.delete(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}`, settings);
}

export const getEmkProject = async () => {
    let teamId = localStorage.getItem('current_team_id');
    const settings = {
        headers: {
            'Authorization': `Bearer ${getAccessToken()}`
        }
    };

    return axios.get(`${BASE_URL}/api/emk/project?team_id=${teamId}`, settings);
}

export const getEmkProjectExtend = async (namespaceId) => {
    let teamId = localStorage.getItem('current_team_id');
    const settings = {
        headers: {
            'Authorization': `Bearer ${getAccessToken()}`
        }
    };

    return axios.get(`${BASE_URL}/api/emk/project/extended?team_id=${teamId}&id=${namespaceId}`, settings);
}

export const createEmkProject = async (currentTeam) => {
    let projectName = currentTeam.name.split('temp_');
    if (projectName.length === 2) {
        projectName = projectName[1];
    } else {
        projectName = currentTeam;
    }
    let data = {
        "name": currentTeam.name,
        "purpose": ""
    }
    const settings = {
        headers: {
            'Authorization': `Bearer ${getAccessToken()}`
        }
    };
    return axios.post(`${BASE_URL}/api/emk/project?team_id=${currentTeam.id}`, data, settings);
}

export const getEmkSecrets = async () => {
    let currentNamespace = localStorage.getItem('current_namespace');
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.get(`https://emk.fuga.cloud/api/namespaces/${currentNamespace}/cloudprovidersecrets`, settings);
}

export const createEmkSecret = async (projectName, appCredData, identityUrl, osUserData) => {
    let currentNamespace = localStorage.getItem('current_namespace');

    let data = {
        "metadata": {
          "name": appCredData.name.toLowerCase(),
          "namespace": currentNamespace,
          "secretRef": {
              "name": appCredData.name.toLowerCase(),
              "namespace": currentNamespace,
          },
        },
        "data": {
            "domainName": "fuga-federated",
            "tenantName": projectName,
            "applicationCredentialName": appCredData.name.toLowerCase(),
            "applicationCredentialSecret": appCredData.secret,
            "username": osUserData.name,
        },
    }
    if (identityUrl) {
        data.data['OS_AUTH_URL'] = identityUrl;
        data.metadata.dnsProviderName = 'openstack-designate';
    } else {
        data.metadata.cloudProfileName = 'fugacloud';
        data.metadata.cloudProviderKind = 'openstack';
    }
    // data.metadata.labels = {"networking.extensions.gardener.cloud/calico":"true","operatingsystemconfig.extensions.gardener.cloud/gardenlinux":"true","provider.extensions.gardener.cloud/openstack":"true"};

    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.post(`https://emk.fuga.cloud/api/namespaces/${currentNamespace}/cloudprovidersecrets`, data, settings);
}

export const deleteEmkSecret = async (namespace, name) => {
    let currentNamespace = localStorage.getItem('current_namespace');
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.delete(`https://emk.fuga.cloud/api/namespaces/${namespace}/cloudprovidersecrets/${name}`, settings);
}


export const updateWorkers = async (namespace, cluster, data) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.patch(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}/spec/provider`, data, settings);
}

export const updateAddons = async (namespace, cluster, data) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.put(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}/spec/addons`, data, settings);
}

export const upgradeCluster = async (namespace, cluster, data) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.put(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}/spec/kubernetes/version`, data, settings);
}

export const emkClusterDns = async (namespace, cluster, data) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.put(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}/spec/dns`, data, settings);
}

export const staticTokenKubeconfig = async (namespace, cluster, data) => {
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.put(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}/spec/kubernetes/enableStaticTokenKubeconfig`, data, settings);
}

export const getEmkMembers = async () => {
    let currentNamespace = localStorage.getItem('current_namespace');
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.get(`https://emk.fuga.cloud/api/namespaces/${currentNamespace}/members`, settings);
}

export const getEmkMemberDetails = async (name) => {
    let currentNamespace = localStorage.getItem('current_namespace');
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.get(`https://emk.fuga.cloud/api/namespaces/${currentNamespace}/members/${name}`, settings);
}

export const createEmkMembers = async (data) => {
    let currentNamespace = localStorage.getItem('current_namespace');
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.post(`https://emk.fuga.cloud/api/namespaces/${currentNamespace}/members`, data, settings);
}

export const deleteEmkMembers = async (name) => {
    let currentNamespace = localStorage.getItem('current_namespace');
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.delete(`https://emk.fuga.cloud/api/namespaces/${currentNamespace}/members/${name}`, settings);
}

export const updateEmkMembers = async (name, description, roles) => {
    let currentNamespace = localStorage.getItem('current_namespace');
    let data = {
        roles: roles,
        description: description,
    }
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.put(`https://emk.fuga.cloud/api/namespaces/${currentNamespace}/members/${name}`, data, settings);
}

export const resetServiceAccount = async (name, data) => {
    let currentNamespace = localStorage.getItem('current_namespace');
    const settings = {
        headers: {
          'x-requested-with': 'XMLHttpRequest',
        },
        withCredentials: true,
    };

    return axios.post(`https://emk.fuga.cloud/api/namespaces/${currentNamespace}/members/${name}`, data, settings);
}

export const getNodeStats = async (projectId, data) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`${BASE_URL}/api/emk/stats/project/nodes?team_id=${teamId}&project=${projectId}&start=${data.start}&end=${data.end}&step=${data.step}`, settings);
}

export const emkHA = async (namespace, cluster, data) => {
  const settings = {
      headers: {
        'x-requested-with': 'XMLHttpRequest',
      },
      withCredentials: true,
  };

    return axios.put(`https://emk.fuga.cloud/api/namespaces/${namespace}/shoots/${cluster}/spec/controlPlane/highAvailability`, data, settings); 
}

export const emkLogout = async () => {
  const settings = {
      headers: {
        'x-requested-with': 'XMLHttpRequest',
      },
      withCredentials: true,
  };

  return axios.get(`https://emk.fuga.cloud/auth/logout`, settings);
}

export const downloadAdminKubeConfig = async (name, time) => {
  let currentNamespace = localStorage.getItem('current_namespace');
  let data = {"expirationSeconds": time};

  const settings = {
      headers: {
        'x-requested-with': 'XMLHttpRequest',
      },
      withCredentials: true,
  };

    return axios.post(`https://emk.fuga.cloud/api/namespaces/${currentNamespace}/shoots/${name}/adminkubeconfig`, data, settings);
}

export const editDualApproval = async (namespaceId, data) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
        'Authorization': `Bearer ${getAccessToken()}`
    }
  };
  return axios.patch(`${BASE_URL}/api/emk/project/dual-approval-shoot-deletion?team_id=${teamId}&id=${namespaceId}`, data, settings);
}